import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectBaggageAndPersonalItemsSCTIStep, makeSelectBaggageAndPersonalItemsSCTIStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormBaggageDelay,
  resetFormBaggageBeenReturned,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { stepBaggageAndPersonalItemsSCTILookup, listPolicyTypeForCellCaptiveSCTIAustralia, listPolicyTypeForCellCaptiveSCTINewZealand, listPolicyTypeForCellCaptivePartnerInsurance } from '../../FastCover/dataMapper/claimCodeMapper';
import { AdditionalList } from './components/Additional';
import { DescriptionList } from './components/DescriptionOfItem';
import { SpecifiedItemList } from './components/SpecifiedItem';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectInitClaimTypeList, makeSelectSpecifiedItems, makeSelectPolicyTypeCode } from '../../App/selectors';
import {
  makeSelectDepreciationTypes,
} from '../../ClaimList/selectors';
export class BaggageAndPersonalItemsSCTIStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onPrescriptionMedicinesNotInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesNotInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionMedicinesForInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesForInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  // Baggage Delay
  onBaggageDelayChange = (data) => {
    this.props.onFormDataChange('form.infoBaggageDelayItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Essential medication
  onEssentialMedicationChange = (data) => {
    this.props.onFormDataChange('form.infoEssentialMedicationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Jewellery or traditional watches
  onJewelleryOrTraditionalWatchesChange = (data) => {
    this.props.onFormDataChange('form.infoJewelleryOrTraditionalWatchesItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Laptops, tablets or cameras
  onLaptopsTabletsOrCamerasChange = (data) => {
    this.props.onFormDataChange('form.infoLaptopsTabletsOrCamerasItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Other unspecified items
  onOtherUnspecifiedItemsChange = (data) => {
    this.props.onFormDataChange('form.infoOtherUnspecifiedItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Specified high value items (if available via API)
  onSpecifiedHighValueItemsChange = (data) => {
    this.props.onFormDataChange('form.infoSpecifiedHighValueItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Bank cards or travel documents
  onBankCardsOrTravelDocumentsChange = (data) => {
    this.props.onFormDataChange('form.infoBankCardsOrTravelDocumentsItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Cash
  onCashChange = (data) => {
    this.props.onFormDataChange('form.infoCashItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const { infoMedicalExpensesItems } = this.props.form;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    if (propertyName === 'form.wereYourExpensesIncurredAsAResultOfTerrorism') {
      if (infoMedicalExpensesItems && infoMedicalExpensesItems.length > 0) {
        const firstItem = infoMedicalExpensesItems[0];
        const resetFirstItem = {
          ...firstItem,
          id: new Date().getTime().toString(),
          selectedClaimFor: [],
          descriptionOfItem: '',
          dateOfExpenses: '',
          amountClaimed: '',
          currency: '',
        };

        const updatedItems = [resetFirstItem, ...infoMedicalExpensesItems.slice(1)];
        this.props.onFormDataChange('form.infoMedicalExpensesItems', fromJS(updatedItems));
      }
    }
    if (propertyName === 'form.hasYourBaggageBeenReturnedToYou') {
      this.props.onResetFormBaggageBeenReturned();
    }
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatHappenedToYourBaggageAndPersonalItems } = this.props.form;
    const expensesSelected = !!whatHappenedToYourBaggageAndPersonalItems && typeof whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
      ? whatHappenedToYourBaggageAndPersonalItems.toJS()
      : whatHappenedToYourBaggageAndPersonalItems || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      if (name === 'Baggage delay') {
        this.props.onResetFormBaggageDelay();
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleExpensesDamagedSelected = (propertyName) => (event) => {
    const { whatItemsAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatItemsAreYouClaimingFor && typeof whatItemsAreYouClaimingFor.toJS === 'function'
      ? whatItemsAreYouClaimingFor.toJS()
      : whatItemsAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      // if (name === 'Baggage delay') {
      //   this.props.onResetFormBaggageDelay();
      // }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  // Baggage Delay
  renderBaggageDelayItems() {
    const { infoBaggageDelayItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoBaggageDelayItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onBaggageDelayChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Essential medication
  renderEssentialMedicationItems() {
    const { infoEssentialMedicationItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoEssentialMedicationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onEssentialMedicationChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Jewellery or traditional watches
  renderJewelleryOrTraditionalWatchesItems() {
    const { infoJewelleryOrTraditionalWatchesItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoJewelleryOrTraditionalWatchesItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, depreciationTypes, claimTypes } = this.props;
    const claimCode = stepBaggageAndPersonalItemsSCTILookup.jewelleryOrTraditionalWatches.claimCode;
    const claimType = claimTypes.find((x) => x.claimCode === claimCode);
    const depreciationTypesByClaimCode = claimType ? depreciationTypes.filter((x) => x.depreciationId === claimType.depreciatedId) : [];
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionList
          data={newMedicalExpenseItems}
          onChange={this.onJewelleryOrTraditionalWatchesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          depreciationTypes={depreciationTypesByClaimCode}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Laptops, tablets or cameras
  renderLaptopsTabletsOrCamerasItems() {
    const { infoLaptopsTabletsOrCamerasItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoLaptopsTabletsOrCamerasItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, depreciationTypes, claimTypes } = this.props;
    const claimCode = stepBaggageAndPersonalItemsSCTILookup.laptopsTabletsOrCameras.claimCode;
    const claimType = claimTypes.find((x) => x.claimCode === claimCode);
    const depreciationTypesByClaimCode = claimType ? depreciationTypes.filter((x) => x.depreciationId === claimType.depreciatedId) : [];
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionList
          data={newMedicalExpenseItems}
          onChange={this.onLaptopsTabletsOrCamerasChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          depreciationTypes={depreciationTypesByClaimCode}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Other unspecified items
  renderOtherUnspecifiedItems() {
    const { infoOtherUnspecifiedItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoOtherUnspecifiedItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, depreciationTypes, claimTypes } = this.props;
    const claimCode = stepBaggageAndPersonalItemsSCTILookup.otherUnspecifiedTtems.claimCode;
    const claimType = claimTypes.find((x) => x.claimCode === claimCode);
    const depreciationTypesByClaimCode = claimType ? depreciationTypes.filter((x) => x.depreciationId === claimType.depreciatedId) : [];
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionList
          data={newMedicalExpenseItems}
          onChange={this.onOtherUnspecifiedItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          depreciationTypes={depreciationTypesByClaimCode}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Specified high value items
  renderSpecifiedHighValueItems() {
    const { infoSpecifiedHighValueItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoSpecifiedHighValueItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, depreciationTypes, claimTypes, specifiedItems, policyTypeCode } = this.props;
    const claimCode = stepBaggageAndPersonalItemsSCTILookup.specifiedHighValueItems.claimCode;
    const claimType = claimTypes.find((x) => x.claimCode === claimCode);
    const depreciationTypesByClaimCode = claimType ? depreciationTypes.filter((x) => x.depreciationId === claimType.depreciatedId) : [];
    const isReadOnly = submitted || isSummary;
    const isCurrencyAUD = listPolicyTypeForCellCaptiveSCTIAustralia.includes(policyTypeCode);
    const isCurrencyNZD = listPolicyTypeForCellCaptiveSCTINewZealand.includes(policyTypeCode) || listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    return (
      <div>
        <SpecifiedItemList
          data={newMedicalExpenseItems}
          onChange={this.onSpecifiedHighValueItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          depreciationTypes={depreciationTypesByClaimCode}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
          specifiedItems={specifiedItems}
          isCurrencyAUD={isCurrencyAUD}
          isCurrencyNZD={isCurrencyNZD}
        />
      </div>
    );
  }

  // Bank cards or travel documents
  renderBankCardsOrTravelDocumentsItems() {
    const { infoBankCardsOrTravelDocumentsItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoBankCardsOrTravelDocumentsItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onBankCardsOrTravelDocumentsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Cash
  renderCashItems() {
    const { infoCashItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoCashItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onCashChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderBaggageDelay() {
    const {
      hasYourBaggageBeenReturnedToYou,
      dateWhenYourLuggageWasReturned,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.hasYourBaggageBeenReturnedToYou} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={hasYourBaggageBeenReturnedToYou === 'true'}
                  onChange={this.handleChange('form.hasYourBaggageBeenReturnedToYou')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={hasYourBaggageBeenReturnedToYou === 'false'}
                  onChange={this.handleChange('form.hasYourBaggageBeenReturnedToYou')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {hasYourBaggageBeenReturnedToYou === 'true' && (
          <div className="ml-3">
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateWhenYourLuggageWasReturned"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateWhenYourLuggageWasReturned}
                  fieldName={messages.dateWhenYourLuggageWasReturned}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateWhenYourLuggageWasReturned"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateWhenYourLuggageWasReturned')}
                    value={dateWhenYourLuggageWasReturned}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-6 col-sm-6">
              </div>
            </div>
          </div>
        )}
        {this.renderBaggageDelayItems()}
      </div>
    );
  }

  renderLostStolenOrDamagedItems() {
    const {
      whatItemsAreYouClaimingFor,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, policyTypeCode } = this.props;
    const isReadOnly = submitted || isSummary;
    const expensesSelected = !!whatItemsAreYouClaimingFor && typeof whatItemsAreYouClaimingFor.toJS === 'function'
      ? whatItemsAreYouClaimingFor.toJS()
      : whatItemsAreYouClaimingFor || [];
    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const domesticPolicyTypes = ['DOM-AU', 'DOM-NZ'];
    const isDomestic = domesticPolicyTypes.includes(policyTypeCode);
    return (
      <div className="app-content">
        <div className={'row'} style={{ paddingTop: 10 }}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.whatItemsAreYouClaimingFor} />
            </PageSectionHeader>
          </div>
          <div className={'col-sm-12 form-group'}>
            {(!isInternationalStudent && !isDomestic) && (
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Essential medication"
                  checked={expensesSelected.includes('Essential medication')}
                  onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.essentialMedication} />
                </span>
                {expensesSelected.includes('Essential medication') && (
                  <div className="col-sm-12 form-group">
                    {this.renderEssentialMedicationItems()}
                  </div>
                )}
              </div>
            )}
            <div className={'col-sm-12 form-group'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="Jewellery or traditional watches"
                checked={expensesSelected.includes('Jewellery or traditional watches')}
                onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
              />
              <span>
                <FormattedMessage {...messages.jewelleryOrTraditionalWatches} />
              </span>
              {expensesSelected.includes('Jewellery or traditional watches') && (
                <div className={'col-sm-12 form-group'}>
                  {this.renderJewelleryOrTraditionalWatchesItems()}
                </div>
              )}
            </div>
            <div className={'col-sm-12 form-group'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="Laptops, tablets or cameras"
                checked={expensesSelected.includes('Laptops, tablets or cameras')}
                onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
              />
              <span>
                <FormattedMessage {...messages.laptopsTabletsOrCameras} />
              </span>
              {expensesSelected.includes('Laptops, tablets or cameras') && (
                <div className={'col-sm-12 form-group'}>
                  {this.renderLaptopsTabletsOrCamerasItems()}
                </div>
              )}
            </div>
            <div className={'col-sm-12 form-group'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="Other unspecified items"
                checked={expensesSelected.includes('Other unspecified items')}
                onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
              />
              <span>
                <FormattedMessage {...messages.otherUnspecifiedItems} />
              </span>
              {expensesSelected.includes('Other unspecified items') && (
                <div className={'col-sm-12 form-group'}>
                  {this.renderOtherUnspecifiedItems()}
                </div>
              )}
            </div>
            {!isInternationalStudent && (
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Specified high value items"
                  checked={expensesSelected.includes('Specified high value items')}
                  onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.specifiedHighValueItems} />
                </span>
                {expensesSelected.includes('Specified high value items') && (
                  <div className={'col-sm-12 form-group'}>
                    {this.renderSpecifiedHighValueItems()}
                  </div>
                )}
              </div>
            )}
            {!isDomestic && (
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Bank cards or travel documents"
                  checked={expensesSelected.includes('Bank cards or travel documents')}
                  onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.bankCardsOrTravelDocuments} />
                </span>
                {expensesSelected.includes('Bank cards or travel documents') && (
                  <div className={'col-sm-12 form-group'}>
                    {this.renderBankCardsOrTravelDocumentsItems()}
                  </div>
                )}
              </div>
            )}
            {!isDomestic && (
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Cash"
                  checked={expensesSelected.includes('Cash')}
                  onChange={this.handleExpensesDamagedSelected('form.whatItemsAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.cash} />
                </span>
                {expensesSelected.includes('Cash') && (
                  <div className={'col-sm-12 form-group'}>
                    {this.renderCashItems()}
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      whatHappenedToYourBaggageAndPersonalItems,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl, policyTypeCode } = this.props;
    const isReadOnly = submitted || isSummary;

    const domesticPT = ['DOM-AU', 'DOM-NZ', 'DOM-PI'];
    const isDomestic = domesticPT.includes(policyTypeCode);
    
    const expensesSelected = !!whatHappenedToYourBaggageAndPersonalItems && typeof whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
      ? whatHappenedToYourBaggageAndPersonalItems.toJS()
      : whatHappenedToYourBaggageAndPersonalItems || [];
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              {isDomestic ?
                (<FormattedMessage {...messages.thisSectionRelatesToExpensesForYourBaggage} />) :
                (<FormattedMessage {...messages.thisSectionRelatesToExpensesForYourBaggagePersonalItemsCashAndTravelDocuments} />)
              }
            </PageSectionHeader>
          </div>
        </div>
        <div className={'ml-1 row'}>
          <div className={'col-sm-12 form-group'}>
            <Validate
              name="whatHappenedToYourBaggageAndPersonalItems"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={expensesSelected}
              fieldName={messages.whatHappenedToYourBaggageAndPersonalItems}
            >
              <div style={{ paddingTop: 20 }} className="col-sm-12 form-group pd-1">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Baggage delay"
                  checked={expensesSelected.includes('Baggage delay')}
                  onChange={this.handleExpensesSelected('form.whatHappenedToYourBaggageAndPersonalItems')}
                />
                <span>
                  <FormattedMessage {...messages.baggageDelay} />
                </span>
                {expensesSelected.includes('Baggage delay') && (
                  <div className="col-sm-12 form-group">
                    {this.renderBaggageDelay()}
                  </div>
                )}
              </div>
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Lost, stolen or damaged items"
                  checked={expensesSelected.includes('Lost, stolen or damaged items')}
                  onChange={this.handleExpensesSelected('form.whatHappenedToYourBaggageAndPersonalItems')}
                />
                <span>
                  <FormattedMessage {...messages.lostStolenOrDamagedItems} />
                </span>
                {expensesSelected.includes('Lost, stolen or damaged items') && (
                  <div className={'col-sm-12 form-group'}>
                    {this.renderLostStolenOrDamagedItems()}
                  </div>
                )}
              </div>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whatHappenedToYourBaggageAndPersonalItems}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

BaggageAndPersonalItemsSCTIStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormBaggageDelay: PropTypes.func,
  onResetFormBaggageBeenReturned: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  depreciationTypes: PropTypes.any,
  claimTypes: PropTypes.any,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  specifiedItems: PropTypes.any,
  policyTypeCode: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectBaggageAndPersonalItemsSCTIStep(),
  errors: makeSelectBaggageAndPersonalItemsSCTIStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  depreciationTypes: makeSelectDepreciationTypes(),
  claimTypes: makeSelectInitClaimTypeList(),
  specifiedItems: makeSelectSpecifiedItems(),
  policyTypeCode: makeSelectPolicyTypeCode(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormBaggageDelay: () => dispatch(resetFormBaggageDelay()),
  onResetFormBaggageBeenReturned: () => dispatch(resetFormBaggageBeenReturned()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'baggageAndPersonalItemsSCTIStep', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(BaggageAndPersonalItemsSCTIStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/index.js